
import { StateItem, buildStateItem } from '@/models/alo/StateItem';
import { AloSejour } from '@/models/alo/AloSejour';
import { AloUser } from '@/models/alo/AloUser';
import { AloCommande } from '@/models/alo/AloCommande';
import { AloMailTemplate } from '@/models/alo/AloMailTemplate';
import { AloMailSkin } from '@/models/alo/AloMailSkin';
import { AloPanStatus } from '@/models/alo/AloPanStatus';

export interface IAdministrationState {     
    sejourStatus: string
    sejourDic: {[id:number]:AloSejour}
    sejourList: StateItem<number[]>
    lastSejourQuery : Date|null

    userStatus: string
    userDic: {[id:number]:AloUser}
    userList: StateItem<number[]>

    commandeStatus: string
    commandeDic: {[id:number]:AloCommande}
    commandeList: StateItem<number[]>
    lastCommandeQuery : Date|null

    mailTemplateStatus: string
    mailTemplateDic: {[id:number]:AloMailTemplate}
    mailTemplateList: StateItem<number[]>

    mailSkinStatus: string
    mailSkinDic: {[id:number]:AloMailSkin}
    mailSkinList: StateItem<number[]>

    panStatusStatus: string
    panStatusDic: {[id:number]:AloPanStatus}
    panStatusList: StateItem<number[]>
}

//Initial State
const state: IAdministrationState = {  
    
    sejourStatus:'',
    sejourDic: {} as {[id:number]:AloSejour},
    sejourList: buildStateItem([] as number[],-5),
    lastSejourQuery:null,

    userStatus:'',
    userDic: {} as {[id:number]:AloUser},
    userList: buildStateItem([] as number[],-5),

    commandeStatus:'',
    commandeDic: {} as {[id:number]:AloCommande},
    commandeList: buildStateItem([] as number[],-5),
    lastCommandeQuery:null,

    mailTemplateStatus:'',
    mailTemplateDic: {} as {[id:number]:AloMailTemplate},
    mailTemplateList: buildStateItem([] as number[],-5),

    mailSkinStatus:'',
    mailSkinDic: {} as {[id:number]:AloMailSkin},
    mailSkinList: buildStateItem([] as number[],-5),

    panStatusStatus:'',
    panStatusDic: {} as {[id:number]:AloPanStatus},
    panStatusList: buildStateItem([] as number[],-5),
  
}
export default state